var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMldb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-MLDB_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MLDB_",
    "data-name": "MLDB ",
    clipPath: "url(#clip-MLDB_)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(-2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    transform: "translate(16 171)",
    fill: "#070000",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 481,
    height: 258,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 480,
    height: 257,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    transform: "translate(23 181)",
    fill: "#070000",
    stroke: "#707070",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 481,
    height: 176,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 478,
    height: 173,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(6 14)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TRAIN_NO.",
    "data-name": "TRAIN NO.",
    transform: "translate(23 172)",
    fill: "#f2f4f6",
    fontSize: 14,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "TRAIN NO.")), /*#__PURE__*/React.createElement("text", {
    id: "TRAIN_NAME",
    "data-name": "TRAIN NAME",
    transform: "translate(175 172)",
    fill: "#f2f4f6",
    fontSize: 14,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "TRAIN NAME")), /*#__PURE__*/React.createElement("text", {
    id: "EXPT._TIME_A_D_PF_NO.",
    "data-name": "EXPT. TIME A/D PF NO.",
    transform: "translate(341 172)",
    fill: "#f2f4f6",
    fontSize: 14,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "EXPT. TIME A/D PF NO."))), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    transform: "translate(29 225)",
    fill: "#b2a7a7",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 468,
    height: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 467,
    height: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_14304_\\u0939\\u0930\\u093F\\u0926\\u094D\\u0935\\u093E\\u0930_\\u0926\\u093F\\u0932\\u094D\\u0932\\u0940_\\u090F\\u0915\\u094D\\u0938\\u092A\\u094D\\u0930\\u0947\\u0938_13:50_D_4",
    "data-name": "14304          \\u0939\\u0930\\u093F\\u0926\\u094D\\u0935\\u093E\\u0930 \\u0926\\u093F\\u0932\\u094D\\u0932\\u0940 \\u090F\\u0915\\u094D\\u0938\\u092A\\u094D\\u0930\\u0947\\u0938                       13:50  D    4",
    transform: "translate(36.5 230)",
    fill: "#f2f4f6",
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17,
    xmlSpace: "preserve"
  }, "14304          "), /*#__PURE__*/React.createElement("tspan", {
    y: 17,
    fontFamily: "NirmalaUI-Bold, Nirmala UI"
  }, "\u0939\u0930\u093F\u0926\u094D\u0935\u093E\u0930"), /*#__PURE__*/React.createElement("tspan", {
    y: 17
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 17,
    fontFamily: "NirmalaUI-Bold, Nirmala UI"
  }, "\u0926\u093F\u0932\u094D\u0932\u0940"), /*#__PURE__*/React.createElement("tspan", {
    y: 17
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 17,
    fontFamily: "NirmalaUI-Bold, Nirmala UI"
  }, "\u090F\u0915\u094D\u0938\u092A\u094D\u0930\u0947\u0938"), /*#__PURE__*/React.createElement("tspan", {
    y: 17,
    xmlSpace: "preserve"
  }, "                       13:50  D    4"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(0 41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_42-2",
    "data-name": "Rectangle 42",
    transform: "translate(29 225)",
    fill: "#b2a7a7",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 468,
    height: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 467,
    height: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_12392_SHRAMJEEVI_SUPERFAST_EXPRESS_13:53_D_2",
    "data-name": "12392    SHRAMJEEVI SUPERFAST EXPRESS    13:53   D      2",
    transform: "translate(36.5 230)",
    fill: "#f2f4f6",
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17,
    xmlSpace: "preserve"
  }, "12392    SHRAMJEEVI SUPERFAST EXPRESS    13:53   D      2"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(0 82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_42-3",
    "data-name": "Rectangle 42",
    transform: "translate(29 225)",
    fill: "#b2a7a7",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 468,
    height: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 467,
    height: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_14521_\\u0A07\\u0A70\\u0A1F\\u0A30\\u0A38\\u0A3F\\u0A1F\\u0A40_\\u0A10\\u0A15\\u0A38\\u0A2A\\u0A4D\\u0A30\\u0A48\\u0A71\\u0A38_13:57_D_1",
    "data-name": "14521          \\u0A07\\u0A70\\u0A1F\\u0A30\\u0A38\\u0A3F\\u0A1F\\u0A40 \\u0A10\\u0A15\\u0A38\\u0A2A\\u0A4D\\u0A30\\u0A48\\u0A71\\u0A38                           13:57   D     1",
    transform: "translate(36.5 230)",
    fill: "#f2f4f6",
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17,
    xmlSpace: "preserve"
  }, "14521          "), /*#__PURE__*/React.createElement("tspan", {
    y: 17,
    fontFamily: "NirmalaUI-Bold, Nirmala UI"
  }, "\u0A07\u0A70\u0A1F\u0A30\u0A38\u0A3F\u0A1F\u0A40"), /*#__PURE__*/React.createElement("tspan", {
    y: 17
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 17,
    fontFamily: "NirmalaUI-Bold, Nirmala UI"
  }, "\u0A10\u0A15\u0A38\u0A2A\u0A4D\u0A30\u0A48\u0A71\u0A38"), /*#__PURE__*/React.createElement("tspan", {
    y: 17,
    xmlSpace: "preserve"
  }, "                           13:57   D     1"))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    transform: "translate(17.714 91.821)",
    fill: "#110e0e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,478.056,2.274V62.083L0,64.358Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 477.1326599121094 61.12282943725586 L 477.1326599121094 3.234856843948364 L 1.069383382797241 1.042858719825745 L 1.069383382797241 63.31482696533203 L 477.1326599121094 61.12282943725586 M 478.0564575195312 62.0832405090332 L 7.721553993178532e-05 64.35778045654297 L 7.721553993178532e-05 -9.503451292403042e-05 L 478.0564575195312 2.274452447891235 L 478.0564575195312 62.0832405090332 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    transform: "translate(25.125 117.463)",
    fill: "#676060"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,466.1,1.037v28L0,30.074Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 465.1736755371094 28.07341384887695 L 465.1736755371094 2.000830888748169 L 1.067361235618591 1.039210319519043 L 1.067361235618591 29.03503799438477 L 465.1736755371094 28.07341384887695 M 466.0990295410156 29.0370044708252 L 8.109837654046714e-05 30.07429885864258 L 8.109837654046714e-05 -4.747221828438342e-05 L 466.0990295410156 1.037238955497742 L 466.0990295410156 29.0370044708252 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(31.326 95.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TRAIN_NO.-2",
    "data-name": "TRAIN NO.",
    d: "M8.526,7.254H5.55v8.291l-2.359,0V7.252H.226V5.387l8.3.005Zm10.136,8.278-2.691,0-1.618-2.608q-.181-.3-.348-.53t-.338-.4q-.171-.166-.356-.254t-.4-.088h-.632v3.883l-2.347,0V5.394l3.72,0q3.788,0,3.788,2.759,0,.53-.167.979t-.471.809q-.3.36-.736.622t-.961.41V11q.232.071.45.23t.421.371q.2.212.388.456t.337.477ZM12.276,7.107V9.929h1.017q.755,0,1.212-.424t.465-1.068q0-1.329-1.633-1.33ZM28.76,15.524l-2.545,0-.738-2.251-3.692,0-.732,2.254-2.537,0L22.3,5.4l2.773,0Zm-3.819-4-1.115-3.4q-.123-.381-.174-.911H23.6q-.036.445-.181.883l-1.13,3.432Zm7.445,4-2.333,0V5.407l2.333,0Zm11.648-.01-2.347,0L37.43,9.168q-.375-.557-.519-.839h-.029q.058.536.058,1.635v5.553l-2.2,0V5.41l2.51,0,4.1,6.151q.281.415.518.824H41.9q-.058-.352-.058-1.387V5.415h2.2ZM59.705,15.5l-2.336,0L53.132,9.169q-.373-.555-.517-.837h-.029q.057.534.057,1.631V15.5l-2.19,0V5.421l2.5,0,4.081,6.136q.28.414.516.822h.029Q57.52,12.029,57.52,11V5.425h2.185Zm6.682.17q-2.2,0-3.59-1.4T61.409,10.6q0-2.387,1.41-3.861t3.733-1.472q2.193,0,3.547,1.412t1.353,3.716q0,2.37-1.4,3.822T66.388,15.668Zm.1-8.454q-1.215,0-1.93.894t-.715,2.369q0,1.5.715,2.365t1.873.869q1.193,0,1.894-.846t.7-2.346q0-1.564-.679-2.434T66.488,7.213Zm6.876,8.448q-.556,0-.927-.336t-.371-.827q0-.5.382-.827t.952-.323q.578,0,.945.325t.367.823q0,.512-.374.838T73.364,15.662Z",
    transform: "translate(0 0)",
    fill: "#f2f4f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TRAIN_NAME-2",
    "data-name": "TRAIN NAME",
    d: "M8.142,7.088H5.3v8.1l-2.252,0v-8.1H.216V5.264l7.925.005Zm9.679,8.09-2.57,0-1.545-2.548q-.173-.29-.333-.518t-.322-.39q-.163-.162-.34-.249t-.385-.086h-.6v3.795l-2.241,0V5.27l3.552,0q3.617,0,3.617,2.7,0,.518-.159.957t-.45.791q-.291.352-.7.608t-.918.4v.028q.222.069.43.224t.4.363q.194.207.371.445t.322.466Zm-6.1-8.234V9.7h.971q.721,0,1.158-.415T14.3,8.245q0-1.3-1.56-1.3ZM27.465,15.17l-2.431,0-.7-2.2-3.526,0-.7,2.2-2.422,0,3.612-9.9,2.648,0Zm-3.647-3.909L22.754,7.936q-.118-.373-.166-.89h-.055q-.035.435-.173.863l-1.079,3.354Zm7.11,3.906-2.228,0V5.283h2.228Zm11.125-.009-2.241,0-4.067-6.2q-.358-.544-.5-.82h-.028q.055.523.055,1.6v5.427l-2.1,0V5.286l2.4,0L39.489,11.3q.268.406.5.805h.028q-.055-.344-.055-1.356V5.291h2.1Zm14.968-.013-2.231,0L50.742,8.96q-.356-.543-.494-.818h-.027q.055.522.055,1.594v5.415l-2.092,0V5.3l2.386,0,3.9,6q.267.405.493.8h.027q-.055-.343-.055-1.353V5.3h2.087Zm10.853-.009-2.4,0-.7-2.186-3.483,0-.69,2.189-2.393,0L61.78,5.3l2.615,0Zm-3.6-3.885L63.221,7.946q-.116-.37-.164-.885H63q-.034.432-.171.857l-1.066,3.333Zm15.941,3.874-2.168,0V9.257q0-.951.082-2.1h-.054q-.17.9-.306,1.3L75.482,15.13l-1.8,0L71.357,8.524q-.1-.267-.307-1.37h-.061q.089,1.452.089,2.548v5.432l-1.983,0V5.31l3.222,0,1.994,5.82q.238.7.347,1.4H74.7q.184-.815.388-1.417l1.993-5.8,3.133,0Zm8.046-.007-5.833,0V5.319l5.609,0v1.8H84.618V9.3H87.8v1.79h-3.18v2.242l3.641,0Z",
    transform: "translate(154.228 0.225)",
    fill: "#f2f4f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EXPT._TIME_A_D_PF_NO.-2",
    "data-name": "EXPT. TIME A/D PF NO.",
    d: "M6.78,14.819l-5.693,0V5.137l5.474,0V6.916H3.226V9.069h3.1v1.768h-3.1v2.215l3.553,0Zm9.523-.008-2.527,0-1.63-3.148q-.092-.175-.191-.647h-.026q-.046.223-.218.674l-1.638,3.124-2.545,0,3.02-4.839L7.785,5.142l2.6,0,1.354,2.9q.158.344.284.816h.026q.079-.283.3-.843l1.5-2.872,2.375,0L13.387,9.939Zm3.256-3.33v3.327l-2.128,0V5.148l3.334,0q3.567,0,3.567,3.078,0,1.454-1.023,2.353t-2.735.9Zm0-4.661V9.831h.836q1.7,0,1.7-1.522,0-1.488-1.7-1.489Zm12.767.106H29.641V14.8l-2.128,0V6.924H24.837V5.153l7.489,0Zm.768,8.039q-.512,0-.853-.322T31.9,13.85q0-.484.351-.793t.876-.31q.531,0,.869.312t.338.789q0,.491-.344.8T33.093,14.965ZM46.3,6.931H43.624v7.858l-2.119,0V6.93H38.841V5.162l7.456,0Zm3.369,7.852-2.109,0V5.168h2.109Zm12.765-.011-2.074,0V9.032q0-.93.078-2.055h-.052q-.163.883-.293,1.272L57.9,14.776H56.185L53.957,8.314q-.091-.261-.293-1.34H53.6q.085,1.42.085,2.492V14.78l-1.9,0V5.171l3.083,0,1.908,5.693q.228.683.332,1.373h.039q.176-.8.371-1.386l1.907-5.677,3,0Zm7.7-.006-5.581,0V5.179l5.367,0V6.94h-3.27V9.072h3.043v1.751H66.646v2.193l3.484,0Zm13.3-.011-2.274,0L80.5,12.629l-3.3,0-.653,2.13-2.266,0,3.378-9.574,2.477,0Zm-3.411-3.78-1-3.216q-.11-.36-.155-.861h-.052q-.032.42-.162.834l-1.009,3.244ZM89.542,5.2,85.034,16.34l-1.82,0L87.7,5.195Zm.9,9.553V5.2l3.271,0q4.913,0,4.913,4.653,0,2.229-1.34,3.56t-3.573,1.334Zm2.08-7.8V13h1.03q1.351,0,2.12-.84t.769-2.283q0-1.364-.762-2.146T93.541,6.95Zm13.332,4.5v3.283l-2.072,0V5.205l3.245,0q3.472,0,3.472,3.037,0,1.434-1,2.321t-2.662.887Zm0-4.6v2.97h.814q1.653,0,1.653-1.5,0-1.468-1.653-1.469Zm11.29.1h-3.234V9.293h2.972v1.738h-2.972v3.7l-2.066,0V5.211l5.3,0Zm13.33,7.756-2.075,0L124.637,8.75q-.331-.523-.459-.789h-.026q.051.5.051,1.537V14.72l-1.945,0v-9.5h2.219L128.1,11q.248.391.458.775h.025q-.051-.331-.051-1.3V5.222h1.941Zm5.936.16q-1.956,0-3.189-1.324t-1.233-3.457q0-2.25,1.252-3.639t3.316-1.387q1.949,0,3.151,1.331t1.2,3.5q0,2.234-1.246,3.6T136.413,14.875Zm.089-7.969q-1.08,0-1.715.843t-.635,2.233q0,1.409.635,2.229t1.664.819q1.06,0,1.682-.8t.622-2.212q0-1.474-.6-2.294T136.5,6.907Zm6.109,7.963q-.494,0-.824-.316t-.33-.779q0-.476.339-.78t.846-.3q.513,0,.84.307t.326.776q0,.482-.333.79T142.61,14.87Z",
    transform: "translate(314.198 0.458)",
    fill: "#f2f4f6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_04439_\\u092A\\u0932\\u0935\\u0932_-_\\u0917\\u093E\\u091C\\u093C\\u093F\\u092F\\u093E\\u092C\\u093E\\u0926_\\u090F\\u0915\\u094D\\u0938\\u092A\\u094D\\u0930\\u0947\\u0938_13:30_A_5",
    "data-name": "04439          \\u092A\\u0932\\u0935\\u0932 - \\u0917\\u093E\\u091C\\u093C\\u093F\\u092F\\u093E\\u092C\\u093E\\u0926 \\u090F\\u0915\\u094D\\u0938\\u092A\\u094D\\u0930\\u0947\\u0938      13:30          A        5",
    d: "M4.835,17.815Q.575,17.82.575,12q0-3.02,1.153-4.6t3.34-1.58q4.155,0,4.155,5.914,0,2.943-1.134,4.513T4.835,17.815ZM4.952,7.767q-1.705,0-1.705,4.167,0,3.925,1.672,3.924,1.63,0,1.63-4.046T4.952,7.767ZM17.693,6.02v7.3h1.425v1.905H17.693V17.6l-2.387,0V15.228l-5.186,0v-2q.689-.752,1.428-1.645T12.975,9.75q.689-.945,1.282-1.9t1.007-1.829Zm-5.223,7.3h2.837V9.274q-.29.525-.63,1.062t-.713,1.058q-.373.521-.755,1.01T12.469,13.322ZM27.438,6.027v7.289h1.421v1.9H27.438v2.371l-2.38,0V15.221l-5.171,0V13.231q.687-.751,1.424-1.643t1.423-1.836q.687-.944,1.278-1.9t1-1.827ZM22.23,13.319h2.828V9.276q-.289.524-.628,1.061t-.711,1.057q-.372.52-.753,1.009T22.23,13.319Zm8.041,3.89V14.992q1.188.845,2.772.844,1,0,1.554-.42t.556-1.168q0-.773-.688-1.192t-1.892-.418h-1.1v-1.95H32.49q2.309,0,2.309-1.5,0-1.41-1.773-1.41-1.188,0-2.31.748V6.449q1.246-.612,2.9-.61,1.814,0,2.823.8t1.009,2.07q0,2.262-2.348,2.834v.04q1.253.153,1.977.89t.725,1.807q0,1.618-1.211,2.561t-3.346.946Q31.417,17.788,30.27,17.209Zm17.682-5.957q0,1.535-.345,2.745T46.6,16.044q-.661.837-1.614,1.284t-2.162.449q-1.448,0-2.492-.448V15.236q.93.595,2.238.594,1.34,0,2.1-.894t.764-2.582l-.049-.016q-.781,1.134-2.375,1.135-.724,0-1.336-.265t-1.061-.736q-.448-.471-.7-1.123t-.251-1.433q0-.91.3-1.658t.852-1.287q.547-.539,1.312-.832t1.694-.292q.962,0,1.726.367t1.3,1.058q.538.692.821,1.7T47.953,11.251ZM45.332,9.9q0-.442-.115-.832T44.9,8.4q-.205-.282-.5-.447t-.649-.165q-.337,0-.621.145t-.489.4q-.206.253-.321.607T42.2,9.7q0,.451.115.8t.325.591q.21.241.506.366t.658.125q.345,0,.625-.133t.481-.358q.2-.225.312-.531T45.332,9.9ZM105.6,7.423h-1.76V17.514l-2.108,0v-3.07l-.032-.008q-.953.6-1.988.6-.178,0-.5-.032t-.7-.163q-.38-.131-.776-.391t-.716-.71q-.32-.451-.526-1.129t-.206-1.644V7.418H94.476v-1.8l11.123.009Zm-3.868,0-3.338,0V11.1q0,.606.117.993t.315.61q.2.223.465.307t.566.084q.647,0,1.083-.3t.792-.857ZM114.375,17.5v-6.98q-.1-.016-.189-.028t-.2-.012q-.338,0-.588.127t-.411.338q-.161.211-.242.478t-.081.537q0,.111.016.231t.032.231h-1.869q-.048-.366-.125-.729t-.209-.645q-.133-.283-.338-.458t-.5-.175q-.242,0-.415.115t-.29.323q-.117.207-.169.49t-.052.609q0,.828.31,1.49t.822,1.186q.512.525,1.172.935t1.369.735l-.934,1.569q-.314-.119-.8-.369t-1.023-.632q-.54-.382-1.088-.887t-.988-1.131q-.44-.625-.714-1.37t-.274-1.6q0-.717.21-1.355t.6-1.111q.391-.474.944-.749t1.237-.274q.467,0,.818.12t.6.3q.254.183.431.4t.3.4l.04-.008q.161-.295.387-.509t.487-.354q.262-.139.544-.2t.564-.063q.145,0,.3.016t.314.048V7.427l-9.341,0V5.629l13.194.01v1.79h-1.753V17.5ZM128.687,7.435h-1.747V17.491l-2.093,0V15.157l-.048-.008q-.481.31-.991.458t-1.015.148q-.739,0-1.437-.3t-1.241-.818q-.542-.521-.872-1.216t-.33-1.491q0-.732.281-1.364t.763-1.1q.482-.469,1.133-.735t1.389-.266q.128,0,.369.02t.55.1q.309.08.674.235t.742.425l.032-.008v-1.8l-7.18,0V5.639l11.021.009Zm-3.809,3.685q-.457-.532-.947-.731t-.915-.2q-.417,0-.775.147t-.618.4q-.261.25-.41.576t-.149.684q0,.342.137.68t.382.608q.245.27.594.441t.783.171q.425,0,.779-.167t.606-.429q.253-.262.393-.584t.14-.632ZM137.4,17.481V10.525q-.1-.016-.188-.028t-.2-.012q-.336,0-.584.127t-.408.337q-.16.21-.24.476t-.08.536q0,.111.016.23t.032.23H133.9q-.048-.365-.124-.726t-.208-.643q-.132-.282-.336-.456t-.5-.175q-.24,0-.412.115t-.288.321q-.116.206-.168.488t-.052.607q0,.826.308,1.484t.816,1.182q.508.524,1.164.932t1.36.733l-.928,1.564q-.312-.119-.792-.368t-1.016-.63q-.536-.381-1.081-.884t-.981-1.127q-.437-.623-.709-1.365t-.272-1.592q0-.715.208-1.35t.6-1.108q.388-.472.937-.746t1.229-.273q.464,0,.812.119t.6.3q.252.183.428.4t.3.4l.04-.008q.16-.294.384-.508t.484-.353q.26-.139.54-.2t.56-.063q.144,0,.3.016t.312.048V7.439l-9.277,0V5.647l13.1.01V7.441h-1.741V17.479Zm13.552-3.465-4.357,0v-1.75h4.357Zm16.911-6.561h-1.727V17.46l-2.069,0V7.453l-2.9,0V13.4q0,.221-.012.431t-.071.368q-.06.158-.19.257t-.361.1q-.317,0-.675-.177t-.707-.466q-.349-.288-.667-.648t-.56-.727q-.242-.368-.385-.708t-.143-.585q0-.1.036-.206t.139-.182q.1-.079.282-.127t.465-.047h.794V7.451h-2.844V5.669l11.6.009Zm4.985,0h-1.724v9.99l-2.066,0V7.456h-1.75V5.678l5.54,0Zm4.978,0h-1.722V17.45l-2.062,0V7.458H172.3V5.682h1.779q-.443-.978-.443-1.815,0-.631.229-1.191t.707-.977q.478-.417,1.225-.657t1.781-.238q1.239,0,2.34.358T182,2.172q.986.651,1.876,1.57t1.71,2.037H183.7q-.276-.276-.642-.623t-.816-.7q-.449-.355-.966-.69t-1.085-.6Q179.62,2.9,179,2.74T177.75,2.58q-.561,0-.971.125t-.679.354q-.269.228-.4.54t-.126.69q0,.331.1.674t.3.722h1.848Zm13.017.007h-1.715v9.963l-2.054,0v-6.2h-1.993l-.008.024q.425.425.63.961t.2,1.079q0,.5-.169.961t-.512.827q-.343.362-.863.579t-1.222.218q-.8,0-1.439-.283t-1.159-.775q-.517-.492-.907-1.15t-.675-1.411q-.284-.753-.478-1.557t-.3-1.584l1.87-.338q.229,1.45.568,2.423t.73,1.564q.39.591.8.839t.769.248q.4,0,.682-.268t.28-.772q0-.268-.095-.571t-.284-.591q-.189-.287-.473-.54t-.662-.433V9.448h4.712V7.465l-9.8-.005V5.686l13.57.011Zm-9.261,10.277q0-.236.083-.441t.233-.355q.15-.15.359-.237t.461-.087q.244,0,.457.086t.367.24q.154.153.244.362t.091.453q0,.244-.083.449t-.236.351q-.154.146-.363.229t-.453.083q-.244,0-.457-.082t-.367-.236q-.154-.153-.244-.358T181.585,17.744ZM190.3,7.467V5.7l11.275.009V7.473h-1.709v9.947l-2.048,0V14.5l-.024-.008q-.181.134-.4.264t-.475.232q-.259.1-.573.165t-.7.063q-1.005,0-1.756-.4t-1.269-1.045q-.519-.649-.825-1.467t-.425-1.668q.5-.063.845-.22t.55-.381q.208-.224.3-.5t.09-.562q0-.354-.126-.724t-.4-.795Zm4.944,1.842q0,.763-.393,1.341t-1.163.916q.11.464.31.794t.46.539q.259.208.566.306t.636.1q.738,0,1.272-.366t.887-1.018V7.471l-3.148,0q.3.48.436.948T195.239,9.309Zm11.266-1.834H204.8v9.939l-2.044,0V7.473h-1.732V5.7l5.483,0Zm10.533.005h-1.7V17.4l-2.038,0V15.178l-.047-.008q-.516.306-1.035.452t-1.043.146q-.789,0-1.513-.3t-1.275-.823q-.551-.522-.876-1.224t-.325-1.5q0-.706.262-1.33t.739-1.091q.477-.467,1.142-.737t1.47-.27q.149,0,.4.02t.578.1q.324.079.7.239t.785.435l.031-.008v-1.8l-7.342,0V5.709l11.081.009ZM209.2,11.988q0,.33.133.679t.387.631q.254.282.629.467t.86.184q.43,0,.8-.134l-2.134-3.208q-.328.259-.5.62T209.2,11.988Zm4.134-.91q-.516-.525-1.043-.725t-1.02-.2q-.141,0-.27.016t-.254.039l2.063,3.1q.25-.251.387-.553t.137-.592Zm8.619-3.594h-1.7V17.4l-2.035,0V7.481h-1.724V5.717l5.457,0Zm10.1.005h-2.369v3.629h-2.853q-1.011,0-1.564.474t-.553,1.421q0,.524.171.99t.483.818q.311.352.743.555t.953.2q.226,0,.408-.028t.323-.106q-.07-.329-.07-.673,0-.446.117-.861t.342-.736q.225-.321.564-.513t.773-.192q.3,0,.567.109t.462.321q.2.211.315.528t.117.723q0,.368-.1.7t-.252.63q-.155.3-.365.559t-.427.489q.521.852,1.321,1.516l-1.329,1.362q-.56-.5-.96-1.047t-.665-1.141q-.311.1-.614.141t-.614.04q-.568,0-1.112-.159t-1.023-.445q-.479-.285-.883-.692t-.693-.9q-.288-.493-.452-1.061t-.164-1.178q0-.885.276-1.558t.771-1.127q.494-.454,1.187-.685t1.533-.231h1.237V7.486l-6.242,0V5.721l10.641.008Zm10.536.005-3.1,0v4.982q0,.547.1.89t.368.609q.267.265.732.515t1.193.608q.7.351,1.331.682t1.118.705q.483.374.77.826t.286,1.045q0,.492-.217.94t-.658.988l-1.586-1.129q.17-.227.244-.422t.074-.375q0-.289-.194-.523t-.526-.444q-.333-.21-.774-.421t-.937-.452q-.573-.281-1.042-.522t-.841-.491q-.372-.25-.647-.523t-.457-.613q-.182-.34-.271-.761t-.089-.969V7.491h-1.574V5.732l10.47.008V7.5h-1.763v3.722q0,.687-.174,1.171t-.48.792q-.306.308-.724.453t-.906.145q-.317,0-.693-.066t-.67-.175V11.608q.17.1.434.176t.5.074q.232,0,.372-.063t.213-.2q.074-.133.093-.343t.019-.507Zm11.606,5.452v4.418l-2.014,0V14.8l-.015-.008q-.093.062-.243.152t-.359.176q-.208.086-.479.148t-.594.063q-.68,0-1.309-.292t-1.113-.795q-.483-.5-.773-1.181T247,11.623q0-.64.213-1.217t.611-1.014q.4-.437.97-.694t1.3-.257q.517,0,1,.164t1.065.593l.015-.008V7.5l-6.358,0V5.74l21.4.017v1.75h-1.675v9.847l-2.007,0V12.539h-3.963q-.447.3-1.071.436l-.015.031q.447.934,1.124,1.755t1.663,1.669L260,17.857q-.462-.412-.9-.9t-.832-.984q-.393-.5-.736-.988t-.62-.919q-.277-.428-.482-.767t-.32-.533q-.069-.117-.135-.23t-.146-.206q-.081-.093-.2-.148t-.278-.054q-.17,0-.339.066t-.324.175q-.154.109-.285.261T254.188,12.946Zm.023-2.244q.162-.132.355-.226t.4-.152q.2-.058.4-.082t.366-.023q.339,0,.6.086t.455.2q.193.117.32.241t.2.2q.108.117.27.218t.4.1q.208,0,.354-.105t.246-.3q.1-.195.146-.459t.046-.584q0-.631-.177-1.2T258.05,7.5l-3.862,0v3.195Zm9.319.1V7.5l-3.393,0q.293.607.458,1.2t.165,1.226q0,.226-.023.444t-.062.436Zm-11.31.3q-.154-.156-.332-.32t-.386-.292q-.208-.129-.455-.211t-.54-.082q-.355,0-.626.125t-.456.335q-.185.211-.278.491t-.093.593q0,.359.116.671t.332.546q.216.234.529.366t.7.132q.432,0,.722-.164t.459-.425q.17-.261.239-.581t.069-.631Zm25.009-3.588h-1.67v9.832l-2,0V14.68l-.038-.008-3.859,3.2-1.182-1.359,2.157-1.727v-.062q-.376-.1-.775-.334t-.725-.664q-.326-.431-.537-1.1t-.211-1.652V7.507h-1.713V5.757l10.555.008Zm-3.67,0-3.168,0v3.583q0,.591.111.968t.3.594q.188.218.441.3t.537.081q.307,0,.56-.066t.464-.19q.211-.124.395-.3t.36-.381Zm.636-1.53-.222-.42q-.4-.762-.7-1.3t-.552-.89q-.249-.354-.456-.552t-.418-.3q-.211-.1-.445-.121t-.526-.024l-1.566,0V.636l1.428,0q.606,0,1.04.04t.779.207q.345.168.656.5t.675.929q.364.595.832,1.488t1.126,2.176Zm2.5-.216,13.026.01V7.518h-1.664v9.813l-1.993,0v-4.8h-3.936q-.444.3-1.063.435l-.015.031q.222.465.5.9t.616.853q.34.419.753.83t.9.829l-1.261,1.421q-.535-.48-1.055-1.073t-1.006-1.237q-.486-.644-.922-1.311t-.811-1.3q-.375-.633-.674-1.2t-.505-1.009l1.692-.877q.291.753.616,1.1t.67.345q.2,0,.348-.109t.245-.3q.1-.19.142-.454t.046-.582q0-.621-.176-1.195t-.543-1.118l-3.927,0Zm9.37,5.039V7.517l-3.37,0q.29.605.455,1.191t.164,1.222q0,.225-.023.442t-.061.434ZM321.5,5.993V17.3l-2.38,0V8.737q-.2.177-.465.335t-.571.285q-.3.127-.628.216t-.643.127V7.648q.93-.277,1.755-.709t1.489-.948ZM325,16.931V14.812q1.086.808,2.534.807.912,0,1.421-.4t.509-1.117q0-.739-.629-1.14t-1.73-.4h-1V10.7h.928q2.111,0,2.111-1.432,0-1.348-1.621-1.349-1.086,0-2.112.716V6.643q1.139-.585,2.655-.584,1.658,0,2.581.764t.923,1.979q0,2.163-2.147,2.71v.039q1.145.146,1.808.851t.663,1.728q0,1.547-1.107,2.449t-3.06.9Q326.049,17.485,325,16.931Zm10.058-5.088q-.587,0-.978-.365t-.391-.9q0-.554.4-.908t1-.354q.609,0,1,.358t.387.9q0,.562-.395.916T335.058,11.843Zm0,5.633q-.587,0-.978-.368t-.391-.908q0-.554.4-.908t1-.355q.609,0,1,.357t.387.9q0,.562-.395.92T335.058,17.476Zm2.992-.557V14.8q1.082.807,2.524.806.909,0,1.415-.4t.507-1.115q0-.738-.627-1.137t-1.723-.4h-1V10.7h.924q2.1,0,2.1-1.43,0-1.345-1.614-1.346-1.081,0-2.1.714V6.652q1.134-.584,2.644-.583,1.651,0,2.57.763t.919,1.975q0,2.159-2.138,2.7v.038q1.141.146,1.8.849t.66,1.725q0,1.544-1.1,2.444t-3.047.9Q339.095,17.472,338.05,16.919Zm12.316.541q-3.835,0-3.835-5.519,0-2.865,1.038-4.366t3.007-1.5q3.741,0,3.741,5.611,0,2.792-1.021,4.282T350.367,17.46Zm.1-9.534q-1.535,0-1.535,3.954,0,3.724,1.505,3.723,1.467,0,1.467-3.838T350.471,7.926Zm56.82,9.285-2.59,0-.751-2.428-3.757,0-.745,2.43-2.581,0L400.718,6.3l2.821,0ZM403.406,12.9l-1.134-3.67q-.125-.411-.177-.982h-.059q-.037.48-.184.952L400.7,12.9Zm38.094,4V14.854q1.069.68,2.276.679.909,0,1.421-.451t.512-1.222q0-1.611-2.188-1.61-.807,0-1.862.129l.393-6.053,5.516,0v1.95l-3.763,0-.145,2.171q.56-.045.967-.045,1.606,0,2.514.877t.908,2.358q0,1.64-1.082,2.681t-2.935,1.043Q442.526,17.366,441.5,16.9Z",
    transform: "translate(32.909 120.618)",
    fill: "#f2f4f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    transform: "translate(90 154)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    transform: "translate(459 154)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    transform: "translate(414 85)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    transform: "translate(68 85)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 9,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMldb);
export default __webpack_public_path__ + "static/media/MLDB.2696114f9ab7db46f31829f7268cd345.svg";
export { ForwardRef as ReactComponent };